import React from "react";
import imagenVita from "../../Images/logoVitanova.jpg";
import CambiarFormatoFechaHelper from "../../Helpers/CambiarFormatoFechaHelper";
import styles from "./EstadoDeCuentaPagosMantenimientoComponent.module.css";

const statusContrato = {
  1: "Activo",
  2: "Cancelado",
  3: "Inactivo",
  4: "Otorgado",
  5: "Pagado",
  6: "Restructurado",
};

const formatCurrency = (value) =>
  new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
  }).format(parseFloat(value || 0));

const formatDate = (fecha) => {
  if (!fecha) {
    return "-";
  }

  const fechaFormateada = CambiarFormatoFechaHelper(fecha);
  return fechaFormateada || fecha;
};

const EstadoDeCuentaPagosMantenimientoComponent = (props) => {
  const contrato = props.finalDataDetalle?.etapaUno?.[0] || {};
  const pagos = Array.isArray(props.estadoDeCuenta) ? props.estadoDeCuenta : [];

  const totalPagosFinal = React.useMemo(
    () =>
      pagos.reduce(
        (total, pago) => total + (parseFloat(pago.monto) || 0),
        0
      ),
    [pagos]
  );

  const fechaImpresion = new Intl.DateTimeFormat("es-MX", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(new Date());

  return (
    <>
      <div className={`${styles.actions} d-print-none`}>
        <div>
          <h6 className="mb-1">Registro de pagos de mantenimiento</h6>
          <small className="text-muted">
            Este es el formato que se enviara a impresion.
          </small>
        </div>
        <div>
          <button
            className="btn btn-dark btn-sm"
            onClick={() => {
              window.print();
            }}
          >
            Imprimir
          </button>
        </div>
      </div>

      <section
        className={`${styles.printDocument} maintenance-payments-print-document`}
      >
        <header className={styles.header}>
          <div className={styles.brand}>
            <img alt="logoVitanova" src={imagenVita} />
          </div>
          <div className={styles.titleBlock}>
            <p>Funeraria Vitanova</p>
            <h2>Registro de pagos de mantenimiento</h2>
            <span>Fecha de impresion: {fechaImpresion}</span>
          </div>
        </header>

        <div className={styles.summary}>
          <div>
            <span>Contrato</span>
            <strong>
              {contrato.serie || "-"} - {contrato.noContrato || "-"}
            </strong>
          </div>
          <div>
            <span>Fecha de contrato</span>
            <strong>{formatDate(contrato.fechaContrato)}</strong>
          </div>
          <div>
            <span>Estatus</span>
            <strong>{statusContrato[contrato.status] || "-"}</strong>
          </div>
          <div>
            <span>Serie</span>
            <strong>{contrato.serie || "-"}</strong>
          </div>
        </div>

        <div className={styles.clientInfo}>
          <div>
            <span>Titular</span>
            <strong>{contrato.titular || "-"}</strong>
          </div>
          <div>
            <span>Domicilio</span>
            <strong>{contrato.domicilioTitular1 || "-"}</strong>
          </div>
        </div>

        <div className={styles.tableWrap}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>No. Pago</th>
                <th>Fecha pago</th>
                <th>Concepto</th>
                <th className={styles.amount}>Monto</th>
              </tr>
            </thead>
            <tbody>
              {pagos.length > 0 ? (
                pagos.map((pago, index) => (
                  <tr key={`${pago.fechaPago}-${pago.conceptoPago}-${index}`}>
                    <td>{index + 1}</td>
                    <td>{formatDate(pago.fechaPago)}</td>
                    <td>{pago.conceptoPago || "-"}</td>
                    <td className={styles.amount}>
                      {formatCurrency(pago.monto)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className={styles.emptyState}>
                    No hay pagos registrados para este contrato.
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="3">Total pagado</td>
                <td className={styles.amount}>
                  <strong>{formatCurrency(totalPagosFinal)}</strong>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <footer className={styles.footer}>
          <div>
            <span>Pagos registrados</span>
            <strong>{pagos.length}</strong>
          </div>
          <div>
            <span>Total</span>
            <strong>{formatCurrency(totalPagosFinal)}</strong>
          </div>
        </footer>
      </section>
    </>
  );
};

export default EstadoDeCuentaPagosMantenimientoComponent;
